import React, { Component } from "react";
import Header from "./HeaderComponent";
import Footer from "./FooterComponent";
import Home from "./HomeComponent";
import Articles from "./ArticlesComponent";
import Files from "./FilesComponent";
import Gallery from "./GalleryComponent";
import Contact from "./ContactComponent";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

class Main extends Component {
  render() {
    return (
      <div className="App">
        <Router>
        <Header/>
        <div className="main-content d-flex flex-column">
          <Routes>
            <Route path="/home" element={<Home />} />
            <Route exact path="/files" element={<Files />} />
            <Route exact path="/articles" element={<Articles />} />
            <Route exact path="/gallery" element={<Gallery />} />
            <Route exact path="/contacts" element={<Contact />} />
            <Route path="*" element={<Navigate replace to="/home" />} />
          </Routes>
          <Footer className="mt-auto"/>
          </div>
        </Router>
      </div>
    );
  }
}

export default Main;
